module.exports = __webpack_public_path__ + "img/Paul_Headshot-photoaidcom-cropped.381db178.JPG";